<template>
  <div>
    <portal to="page-top-title">Offers</portal>
    <portal to="page-top-right">
      <btn :route="{ name: 'offers-new' }" icon="fa-plus" text>Add New</btn>
    </portal>

    <box-table title="List" url="/offers" :url-query="{ with: ['campaigns'] }" data-prop="offers" :dataCallback="dataCallback" loader @request-after="requestAfter">
      <template slot="table-header">
        <tr>
          <th>ID</th>
          <th>Name</th>
          <th class="text-center">Redirect URL</th>
          <th class="text-center">Compare Clicker Data</th>
          <th class="text-center">Active</th>
          <th>Lifetime</th>
          <th>Stats</th>
          <th class="text-right">Created At</th>
          <th class="text-right"></th>
        </tr>
      </template>
      <template slot="table-body">
        <table-row v-for="offer in offers" :key="`offers-tr-${offer.id}`" :value="offer">
          <td>{{ offer.id }}</td>
          <td>{{ offer.name }}</td>
          <td class="text-center">
            <badge-active :value="!! offer.redirect_url"/>
          </td>
          <td class="text-center">
            <badge-active :value="offer.compare_clicker_data"/>
          </td>
          <td class="text-center">
            <badge-active :value="offer.active"/>
          </td>
          <td>{{ offer.lifetime | secondsToTime }}</td>
          <td>
            <stats-column :stats="offer.stats">
              <div class="td-row" slot="pre-rows">
                <span class="left">Campaigns:</span>
                <span class="right">
                  <badge title="Total">{{ offer.campaigns_count }}</badge>
                </span>
              </div>
            </stats-column>
          </td>
          <td class="text-right">{{ offer.created_at }}</td>
          <td class="text-right">
            <btn :route="{ name: 'offers-edit', params: { id: offer.id } }" icon="fa-edit">Edit</btn>
            <btn :route="{ name: 'offers-single', params: { id: offer.id } }" color="info" icon="fa-eye">Show</btn>
          </td>
        </table-row>
      </template>
    </box-table>
  </div>
</template>

<script>
import secondsToTime from '@/modules/filters/secondsToTime'
import BoxTable from '@/views/components/data/BoxTable'
import Btn from '@/views/components/simple/Btn'
import Badge from '@/views/components/simple/Badge'
import BadgeActive from '@/views/components/simple/BadgeActive'
import StatsColumn from '@/views/components/stats/StatsColumn'

export default {
  name: 'OffersList',
  metaInfo: {
    title: 'Offers'
  },
  components: {
    BoxTable,
    Btn,
    Badge,
    BadgeActive,
    StatsColumn
  },
  data () {
    return {
      offers: []
    }
  },
  methods: {
    dataCallback (data) {
      return data.map((item) => { item.stats = undefined; return item })
    },
    requestAfter () {
      this.loadOfferStats(
        this.offers.map((list) => list.id)
      )
    },
    loadOfferStats (ids) {
      this.$http
        .get('/offers/stats', { params: { ids: ids } })
        .then((res) => {
          const { data: { data } } = res

          this.offers.forEach((offer) => {
            offer.stats = data.find((stats) => stats.id === offer.id)
          })
        })
    }
  },
  filters: {
    secondsToTime
  }
}
</script>
